// @flow

import $ from 'jquery';
import toastr from 'toastr';
import { makeRequest } from './request';
import { dataTablesListing } from './../components/datatables';
import { initSliderTemplatePreview, killSliderTemplatePreview } from './slider-template-preview';

var Routing: any;
let popup;

class Popup {
    body: Object;
    element: Object;
    options: Object;
    templateOverlay: string;
    templatePopup: string;

    constructor(element: Object) {
        this.body = $('body');
        this.element = element;
        this.options = element.data('options');
        this.templateOverlay = '<div class="overlay js-popup-close"></div>';
        this.templatePopup = '<div class="popup"><div class="popup__content"></div><span class="popup__close js-popup-close" title="Close"><span></span></span></div>';
    }

    /**
     * Ukrywa popup
     */
    hidePopup() {
        $('.popup').removeClass('is-active');
        setTimeout(() => {
            $('.overlay').removeClass('is-active');
        }, 300);

        setTimeout(() => {
            this.removePopupHtml();
        }, 500);
    }

    /**
     * Odkrywa gotowy popup (zmienia klase w CSS)
     */
    showPopup() {
        $('.overlay').addClass('is-active');
        setTimeout(() => {
            $('.popup').addClass('is-active');
        }, 200);
    }

    /**
     * TODO: Callback po wklejeniu contentu do popupu, datatables exclude
     */
    insertContentCallback() {
        const identifier = $('.popup__content table').data('tablename');
        dataTablesListing(identifier);
    }

    /**
     * Wkleja pobrany content do poopupu
     * @param {string} html - content do wklejenia do popupu
     */
    insertContent(html: string) {
        // todo: refactor for instance magick
        $('.popup__content').append(html);
        this.showPopup();
        this.insertContentCallback();
    }

    /**
     * Wkleja preview do poopupu
     * @param {string} html - content do wklejenia do popupu
     */
    insertTemplatePreview(html: string) {
        $('.popup__content').append(html);
        this.showPopup();
        initSliderTemplatePreview();
    }

    /**
     * Pobiera zawartosc i wkleja ja do popupu
     */
    fetchContent() {
        const ajaxOptions = this.element.data('ajax');
        const ajaxPreviewOptions = this.element.data('ajax-preview');
        const galleryOptions = this.element.data('gallery');

        if (ajaxOptions !== undefined) {
            const getData = makeRequest(ajaxOptions);
            getData.then((response) => {
                this.insertContent(response.data);
            });
        } else if (ajaxPreviewOptions !== undefined) {
            $('.popup').addClass('popup--template-preview');
            const getData = makeRequest(ajaxPreviewOptions);
            getData.then((response) => {
                this.insertTemplatePreview(response.data);
            });

        } else if (galleryOptions !== undefined) {
            $('.popup').addClass('popup--gallery');
            this.insertContent('<img src="' + galleryOptions + '" alt=""/>');
        } else {
            this.insertContent('Who let the dogs out??');
        }
    }

    /**
     * Usuwa HTML ze struktury popupu
     */
    removePopupHtml() {
        $('.popup, .overlay').remove();

        popup = null;
    }

    /**
     * Dodaje HTML ze struktura popupu do body
     */
    appendPopupHtml() {
        this.body.append(this.templatePopup);
        this.body.append(this.templateOverlay);

        this.fetchContent();

        $(document).on('click', '.js-popup-close', (e: Object) => {
            e.preventDefault();
            this.hidePopup();

            setTimeout(function() {
                killSliderTemplatePreview();
            }, 300);

        });
    }

    init() {
        this.appendPopupHtml();
    }
}

function init() {
    $(document).on('click', '.js-popup', function(e) {
        popup = new Popup($(this));
        popup.init();
        e.preventDefault();
    });
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/popup.js